import { Component, OnInit, ElementRef, Inject, ViewChild, SimpleChanges } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IAccident, IAccidentResponse } from '../../accidents/accidents.interfaces';

import { StripHtmlPipe } from '../../pipes/stripHTMLpipe';
import { DatePipe } from '@angular/common';
import { AccidentsService } from '../../services/accidents/accidents.service';

import * as L from 'leaflet';
import * as moment from 'moment';

@Component({
  selector: 'dialog-data',
  templateUrl: './dialog.component.acc.html',
  styleUrls: ['./dialog.component.acc.scss'],
  providers: [DatePipe, AccidentsService]
})

export class DialogAccidents {
  private accModel: IAccident = {
      'id': '',
      'plate': 'NEW',
      'date': '',
      'time': '',
      'location': '',
      'parish': '',
      'number_of_fatalities': null,
      'number_of_injuries': '',
      'number_of_vehicles': '',
      'number_of_pedestrians': '',
      'number_of_cyclists': '',
      'main_cause': '',
      'long': '',
      'lat': '',
      'involved_plates': ''
  };
  private plate: string;
  public error: string = '';
  public showMap = false;
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editAccidentData: IAccident;
  
  public parish: any[];
  public causeList: any[];
  public plateList: any[];
  public idList: any[];

  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public plateInputValue: string = '';
  public filteredPlates: string[] = [];

  // Matrícules ja seleccionades per aquest accident
  public involvedPlates: string[] = [];
    
  public userInfo: any = {};
  public filterStates(val: string) { }

  // Fallback: Grenada (país), coincidint amb el teu bbox original
  private readonly DEFAULT_LAT = 12.15;
  private readonly DEFAULT_LON = -61.65;
  private readonly DEFAULT_ZOOM = 10;
  private readonly MARKER_ZOOM = 15;

  private map: L.Map | undefined;
  private marker: L.Marker | undefined;

  @ViewChild('plateInput') plateInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private sanitizer: DomSanitizer, private datePipe: DatePipe, public dialogRef: MatDialogRef<DialogAccidents>, @Inject(MAT_DIALOG_DATA) public data: any, public accService: AccidentsService){ 
   this.editAccidentData =  data.dades;
   this.accService.getAutocomplete("parish").subscribe(result => {this.parish = result;});;
   this.accService.getAutocomplete("cause").subscribe(result => {this.causeList = result;});
   this.accService.getAutocomplete("plate").subscribe(result => {this.plateList = result;});
   this.accService.getAutocomplete("id_accident").subscribe(result => {this.idList = result;});
  
   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
   this.userInfo = data.user;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editAccidentData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  afegir(event){
    if(event){
      this.plate = event.value;
    }
  }

  setAny(event, picker) {
    this.data.setFullYear(event.year());
    picker.close();
  }

  ngOnInit(){ 
    // Si editAccidentData.involved_plates ve com a string "AIM-6269,BCD-1234"
    if (this.editAccidentData?.involved_plates) {
      this.involvedPlates = this.editAccidentData.involved_plates
        .split(',')
        .map((p: string) => p.trim())
        .filter((p: string) => p.length > 0);
    }

    this.initInvolvedPlates();
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // si editAccidentData es carrega/canvia després del ngAfterViewInit
    if (this.map && changes['editAccidentData']) {
      this.updateMap();
    }
  }

  private initMap(): void {
    // Fix de les icones per defecte de Leaflet amb Angular CLI/webpack
    delete (L.Icon.Default.prototype as any)._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
      iconUrl: 'assets/leaflet/marker-icon.png',
      shadowUrl: 'assets/leaflet/marker-shadow.png',
    });

    this.map = L.map('map', {
      scrollWheelZoom: true
    }).setView([this.DEFAULT_LAT, this.DEFAULT_LON], this.DEFAULT_ZOOM);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '© OpenStreetMap'
    }).addTo(this.map);

    // Captura de coordenades en clicar el mapa
    this.map.on('click', (e: L.LeafletMouseEvent) => {
      this.onMapClick(e.latlng);
    });

    this.updateMap();
  }

  private updateMap(): void {
    const lat = this.toValidCoord(this.editAccidentData?.lat);
    const long = this.toValidCoord(this.editAccidentData?.long);

    if (lat !== null && long !== null) {
      this.map!.setView([lat, long], this.MARKER_ZOOM);

      if (this.marker) {
        this.marker.setLatLng([lat, long]);
      } else {
        this.marker = L.marker([lat, long]).addTo(this.map!);
      }
    } else {console.log(2);
      // sense coordenades vàlides: torna a la vista per defecte, sense marcador
      this.map!.setView([this.DEFAULT_LAT, this.DEFAULT_LON], this.DEFAULT_ZOOM);
      if (this.marker) {
        this.map!.removeLayer(this.marker);
        this.marker = undefined;
      }
    }
  }

  private toValidCoord(value: string | null | undefined): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const num = Number(value);
    return isNaN(num) ? null : num;
  }

  private onMapClick(latlng: L.LatLng): void {
    const lat = latlng.lat;
    const long = latlng.lng;

    // Desa a l'objecte de l'accident (com a string, igual que al model)
    this.editAccidentData.lat = lat.toFixed(6);
    this.editAccidentData.long = long.toFixed(6);

    // Mou o crea el marcador
    if (this.marker) {
      this.marker.setLatLng([lat, long]);
    } else {
      this.marker = L.marker([lat, long]).addTo(this.map!);
    }
  }


private initInvolvedPlates(): void {
  if (this.editAccidentData?.involved_plates) {
    this.involvedPlates = this.editAccidentData.involved_plates
      .split(',')
      .map((p: string) => p.trim())
      .filter((p: string) => p.length > 0);
  } else {
    this.involvedPlates = [];
  }
  this.filteredPlates = this.getAllPlateStrings();
}

private setupPlatesAutocomplete(): void {
  // ja no cal el pipe amb valueChanges; filtrem manualment amb (input)
  this.filteredPlates = this.getAllPlateStrings();
}

private getAllPlateStrings(): string[] {
  return this.plateList
    ? this.plateList.map(p => (typeof p === 'string' ? p : p.value))
    : [];
}

onPlateInputChange(value: string): void {
  const filterValue = (value || '').toLowerCase();
  this.filteredPlates = this.getAllPlateStrings().filter(plate =>
    plate.toLowerCase().includes(filterValue) &&
    !this.involvedPlates.includes(plate)
  );
}

addPlate(event: MatChipInputEvent): void {
  const input = event.input;
  const value = (event.value || '').trim().toUpperCase();

  if (value && !this.involvedPlates.includes(value)) {
    this.involvedPlates.push(value);
  }

  if (input) {
    input.value = '';
  }

  this.plateInputValue = '';
  this.syncPlatesToModel();
}

private syncPlatesToModel(): void {
  this.editAccidentData.involved_plates = this.involvedPlates.join(',');
}

selectedPlate(event: MatAutocompleteSelectedEvent): void {
  const value = event.option.viewValue;
  if (!this.involvedPlates.includes(value)) {
    this.involvedPlates.push(value);
  }
  this.plateInput.nativeElement.value = '';
  this.plateInputValue = '';
  this.syncPlatesToModel();
}


}
